import React from 'react';

const Userbanner = () => {
  return (
    <>
      <div className="con h-16 md:h-44">
        <img src="/assets/images/Arab-sea-new-Banner-2.jpg" alt="" className='h-full w-full top-0 bg-cover bg-no-repeat' />
      </div>

      <div
        className="py-10 "
        style={{
          background: `transparent url('/assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

          width: '100%',
        }}
      ></div>
    </>
  );
};

export default Userbanner;
